import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTalkToUs } from './TalkToUsPopup';

const LINKS = [
  { to: '/', label: 'Home' },
  { to: '/roi', label: 'The Math' },
  { to: '/fees', label: 'Fees' },
  { to: '/platform', label: 'Platform' },
  { to: '/what-you-get', label: 'What You Get' },
  { to: '/faq', label: 'FAQ' },
];

const EventBrellaNav = () => {
  const { pathname } = useLocation();
  const { openTalkToUs } = useTalkToUs();

  return (
    <nav className="eb-nav">
      <div className="wrap inner">
        <Link to="/" className="brandmark">
          <div className="seal"><span>EB</span></div>
          <div className="brand-name">Event<em>Brella</em></div>
        </Link>
        <div className="nav-links">
          {LINKS.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={pathname === link.to ? 'active' : undefined}
            >
              {link.label}
            </Link>
          ))}
        </div>
        <button type="button" className="btn btn-gold" onClick={openTalkToUs}>
          Talk to Us
        </button>
      </div>
    </nav>
  );
};

export default EventBrellaNav;
